import styled from 'styled-components'
import AppButton from 'Components/AppButton'
import { IS_MRLOFT } from 'Config/config'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import { FAV_AREA_BG_COLOR, PRIMARY_DARK_COLOR } from '@CSSVars/colors'
import { _AnchorText } from '../../styles'

export const _PreconRequestInfo = styled.div`
  background: ${IS_MRLOFT ? 'rgba(191, 60, 72, 0.1)' : FAV_AREA_BG_COLOR};
  border-bottom-left-radius: 10px;
  padding: 9px 20px 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding: 16px 16px 8px 16px;
    margin: 0 27px 0 27px;
    border-radius: 10px;
    align-items: center;
    background: transparent;
    padding-top: 0;
    justify-content: center;
  }
`

export const _RequestInfoText = styled.div`
  ${({ isBold }) =>
    (isBold
      ? `
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    `
      : `
      font-size: 14px;
      font-weight: 500;
      line-height: 26px;
    `)};
  margin: 12px 0 0 0;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin: 0;
    max-width: 271px;
  }
`

export const _PreconForSale = styled(AppButton)`
  width: 100%;
  margin: 24px 12px 32px 0px;
  height: 44px;
  span {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: ${PRIMARY_DARK_COLOR};
  }

`

export const _NearbySchools = styled(_AnchorText)`
  display: none;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
        display: flex;
  }

`
